import { useTranslation } from 'react-i18next';

import { ChartKey } from '@/components/charts/legend';
import { useChartTheme } from '@/components/charts/theme';
import { OVERVIEW_SCORE_LEGEND } from '@/routes/Client/Cage/pages/Health/HealthDashboard/components/LaksvelOverviewChart/laksvelOverviewColors';

interface LaksvelScoreLegendProps {
    /** Alignment and spacing for where the legend sits. */
    className?: string;
}

/** The key to the four Laksvel score colours, for the health overview and the cage dashboard. */
export default function LaksvelScoreLegend(props: LaksvelScoreLegendProps) {
    const { className } = props;
    const { t } = useTranslation('healthModule');
    const chartTheme = useChartTheme();

    return (
        <ChartKey
            className={className}
            entries={OVERVIEW_SCORE_LEGEND.map((item) => ({
                id: item.key,
                label: t(item.labelKey),
                swatch: { shape: 'dot', color: chartTheme.color(item.color) },
            }))}
        />
    );
}
